/**
 * 动态蜂群图验证配置
 * 为新 ValidationEngine 提供验证规则
 */

import type { ValidationConfig } from '../../../core/dataProcessor/types';
import * as utils from '../../../util';

// 🆕 为新 ValidationEngine 导出的配置
export const dynamicBeeSwarmValidationConfig: ValidationConfig = {
  fields: [
    { field: 'x', type: 'string', required: true },
    { field: 'y', type: 'number', required: true },
    { field: 'group', type: ['string', 'date'], required: true },
    { field: 'size', type: 'number', required: false }
  ],
  businessRules: [
    {
      name: 'dynamic-bee-swarm-unique-names',
      validator: (data, layer) => {
        if (!Array.isArray(data)) {
          return true;
        }
        const { encoding } = layer;
        const groupField = encoding?.group as string;
        const xField = encoding?.x as string;

        if (!groupField || !xField) {
          return true;
        }

        // 获取不同的分组值
        const datesSortList = (utils.dataTransform.transform(data.slice(), [
          { type: 'deDuplication', field: groupField },
          { type: 'sort', field: groupField, order: 'ascending' }
        ]) || []) as { [key: string]: string | number }[];

        const { dates } = utils.dataEncoding.encoding(datesSortList, {
          dates: { field: groupField }
        });

        // 检查每个分组内的名称是否唯一
        return dates.every((date: string | number) => {
          const dateData = data.filter(
            (item: Record<string, unknown>) => item[groupField] === date
          );
          const nameList = dateData.map((item: Record<string, unknown>) => item[xField]);
          return nameList.length === new Set(nameList).size;
        });
      },
      message: 'Names in each group period must be unique in dynamic bee swarm chart',
      suggestion: 'Ensure that each item name appears only once within each time period',
      // 关键功能错误，影响图表渲染
      severity: 'error'
    }
  ]
};
